// extracted by mini-css-extract-plugin
export default {"page":"AccountPage_page__aFU95","formContainer":"AccountPage_formContainer__PWIqH","formWrapper":"AccountPage_formWrapper__hoZWU"};